import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef} from 'react';
import {Calendar} from "primereact/calendar";
import moment from "moment/moment";
import '../styles/weekpicker.css'
//@ts-ignore
import bg from 'moment/locale/bg';
import {FormEvent} from "primereact/ts-helpers";
import {useHeaderComponent} from "../hooks/useHeaderComponent";

interface Props {

}

export const WeekPicker: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const {weekPickerState, updateWeekPicker} = useHeaderComponent();

    const dateElRef = useRef<HTMLInputElement | null>();

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const setWeekPickerInputValue = () => {
        if(dateElRef && dateElRef.current && weekPickerState.firstDateOfTheWeek){
            const date = weekPickerState.firstDateOfTheWeek;
            const weekNumber = moment(date).isoWeek();
            moment.locale('bg', [bg]);
            const dateString = moment(date).format('D MMMM yyyy');
            const currentWeekNumber = moment().isoWeek();
            dateElRef.current.value = `${currentWeekNumber === weekNumber ? (f({id: 'current'}) + ' ') : ''}${f({id:'week'})} (${weekNumber}) - ${dateString}`;
        }
    }

    useEffect(() => {
        setWeekPickerInputValue()
    }, [weekPickerState.firstDateOfTheWeek, dateElRef]);

    const handleDateChange = (event: FormEvent) => {
        if(event.value)
            updateWeekPicker(event.value as Date);
    }


    return <Calendar value={weekPickerState.firstDateOfTheWeek} onChange={handleDateChange}
                     onFocus={setWeekPickerInputValue} onBlur={setWeekPickerInputValue} onHide={setWeekPickerInputValue}
                     showWeek
                     pt={{container: {className: 'weekpicker'}, input: {root: {className: 'weekpicker-input'}}, yearPicker: {className: 'weekpicker-yearpicker'}, monthPicker: {className: 'weekpicker-monthpicker'}, buttonbar: {className: 'weekpicker-buttonbar'}}}
                     inputRef={ref => dateElRef.current = ref} showButtonBar readOnlyInput showIcon/>
};
